import { getVisibleLength } from "lib/text/text-content";
import type { ContentNode, RenderingContext } from "lib/types";

const symbolCount = new Map<number, number>();

export function resetSymbolCount() {
  symbolCount.clear();
}

export function getSymbolsOnPage(
  page: number,
  context: RenderingContext
): number {
  if (symbolCount.has(page)) {
    return symbolCount.get(page)!;
  }

  const count = countSymbolsOnPage(page, context);
  symbolCount.set(page, count);
  return count;
}

function countSymbolsOnPage(page: number, context: RenderingContext): number {
  if (!context.layout) return 0;

  // Находим все индексы элементов на странице
  const indicesOnPage = Object.entries(context.layout.elements)
    .filter(([, loc]) => loc.startPage === page)
    .map(([idx]) => parseInt(idx, 10));

  if (indicesOnPage.length === 0) return 0;

  let totalSymbols = 0;

  for (const index of indicesOnPage) {
    const node = getNodeByIndex(index, context);
    if (node) {
      totalSymbols += countSymbolsInNode(node);
    }
  }

  return totalSymbols;
}

function getNodeByIndex(
  index: number,
  context: RenderingContext
): ContentNode | null {
  for (let partIdx = 0; partIdx < context.parts.length; partIdx++) {
    const content = context.parts[partIdx];
    if (!content) continue;

    const tocPartIndex = context.partsStartIndex + partIdx;
    const tocPart = context.toc.Parts[tocPartIndex];
    if (!tocPart) continue;

    const localIndex = index - tocPart.s;
    if (localIndex >= 0 && localIndex < content.length) {
      const node = content[localIndex];
      if (typeof node !== "string") {
        return node;
      }
    }
  }
  return null;
}

function countSymbolsInNode(node: ContentNode): number {
  return getVisibleLength(node);
}
